/**
 * @file emotionConstants.js
 * @description Constants for the Emotion module within the Insight section.
 *              Includes UI label strings, table configurations, messages, and error constants.
 *
 * @module emotionConstants
 *
 * @exports EMOTION_ERRORS    - Error message strings for emotion data fetching.
 * @exports EMOTION_TABS      - Tab configurations for the emotion panel.
 */

export const EMOTION_ERRORS = {
    FETCH_EMOTION_DATA_ERROR: "Error fetching emotion data:",
}

export const EMOTION_TABS = {
    TEXTS: "Texts",
    EMAILS: "Emails",
};
